import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';

import { Helmet } from 'react-helmet';

const cs = require('react-intl/locale-data/cs');
const sk = require('react-intl/locale-data/sk');
addLocaleData(cs);
addLocaleData(sk);
export class LanguageProvider extends React.PureComponent {
    render() {
        return (
            <IntlProvider
                defaultLocale={'cs'}
                locale={this.props.locale}
                messages={this.props.localeStrings}
            >
                <Fragment>
                    <Helmet>
                        <html lang={this.props.locale} />
                    </Helmet>
                    {React.Children.only(this.props.children)}
                </Fragment>
            </IntlProvider>
        );
    }
}

LanguageProvider.propTypes = {
    locale: PropTypes.string,
    localeStrings: PropTypes.object,
    children: PropTypes.element.isRequired
};

function mapStateToProps(state) {
    return {
        locale: state.pageSettings.locale,
        localeStrings: state.pageSettings.localeStrings
    };
}

export default connect(mapStateToProps)(LanguageProvider);
